import { v4 as uuid } from 'uuid';

import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

// partial types
type OldProject = {
  id: string;
  defaultModel: ProjectModel;
  diagram: DiagramSnapshot;
  modelsById: Record<string, ProjectModel>;
};
type Project = {
  id: string;
  diagram: DiagramSnapshot;
  modelsById: Record<string, ProjectModel>;
  targetModelId: string;
};

const DEFAULT_PROJECT_MODEL_ID = '__default__';

/**
 * * on {@link Project} move `defaultModel` to `modelsById` using a new UUID
 * * on {@link ProjectModel} update `namespace` to be the target model namespace
 * * on {@link Project} remove `defaultModel`
 * * on {@link Project} add `targetModelId`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v29 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v29Projects(prevState.projects);
  }

  return nextState;
};

const v29Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, OldProject>
  ).forEach(([projectId, project]) => {
    const { defaultModel, ...nextProject } = project;
    const defaultModelId = uuid();

    const modelsByIri = Object.fromEntries(
      Object.entries(project.diagram.model.modelData.modelsByIri).map(
        ([iri, modelIds]) => [
          iri,
          modelIds.map((modelId) =>
            modelId === DEFAULT_PROJECT_MODEL_ID ? defaultModelId : modelId
          ),
        ]
      )
    );

    projectsById[projectId] = {
      ...nextProject,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            modelsByIri,
          },
        },
      },
      modelsById: {
        ...Object.fromEntries(
          Object.entries(nextProject.modelsById).map(([id, model]) => [
            id,
            { ...model, namespace: defaultModel.namespace },
          ])
        ),
        [defaultModelId]: {
          ...defaultModel,
          id: defaultModelId,
        },
      },
      targetModelId: defaultModelId,
    };
  });

  return { ...prevProjectsState, projectsById };
};
